<script setup lang="ts">
  import {
    mpfNotificationBannerDefaults,
    MpfNotificationBannerProps,
  } from './MpfNotificationBanner.props';
  import './MpfNotificationBanner.scss';

  const props = withDefaults(
    defineProps<MpfNotificationBannerProps>(),
    mpfNotificationBannerDefaults,
  );

  const marginClass = props.marginClass ? props.marginClass : 'mpf-u-margin-top-3';
</script>

<template>
  <div class="mpf-notification-banner" :class="marginClass">
    <div class="mpf-notification-banner__header">
      <h2 class="mpf-notification-banner__title">{{ heading }}</h2>
    </div>

    <div class="mpf-notification-banner__content">
      <slot>
        <p class="mpf-u-margin-bottom-2" v-if="additionalText">{{ additionalText }}</p>
        <p class="mpf-u-margin-bottom-0">If your request is an emergency or you're not sure:</p>
        <ul class="mpf-u-margin-bottom-4">
          <li v-if="organisationPhoneNumber">
            call the surgery on
            <a :href="`tel:${organisationPhoneNumber}`" class="mpf-link">{{
              organisationPhoneNumber
            }}</a>
          </li>
          <li v-if="isNhsJurisdiction">
            if the surgery is closed, phone <a href="tel:111">111</a> or go online to
            <a href="https://111.nhs.uk/" target="_blank" rel="noopener noreferrer" class="mpf-link"
              >Get help for your symptoms - NHS 111</a
            >
          </li>
          <li>in an emergency, phone 999 or go to A&amp;E</li>
        </ul>
      </slot>
    </div>
  </div>
</template>
